import {
  ErrorOutlineOutlined,
  IndeterminateCheckBoxOutlined,
} from '@mui/icons-material';
import { Box, Checkbox, Link, Typography } from '@mui/material';
import { useAICompatibilityTableStyles } from 'components/AITools/constants/styles';
import {
  getAnalysisType,
  getModalCompatibilityIcon,
  isCompatibleDataMissing,
  isModelExists,
  isOrganMismatch,
  isSpeciesMismatch,
  isStainTypeMismatch,
} from 'components/AITools/utilities/common';
import { getSlideViewerURL } from 'components/TeamOverview/components/AiComputeTransactionsCard/utilities';
import { STAIN_TYPE_VALUES } from 'constants/common';
import { SLIDE_VIEWER_URL } from 'constants/urls';

export const AICompatibilityRow = ({
  slide,
  model,
  isChecked,
  setAvailableToProcessSlides,
}) => {
  const { classes } = useAICompatibilityTableStyles();
  const isExists = isModelExists(slide, model);

  const handleOpenResult = () => {
    if (isExists) {
      window.open(getSlideViewerURL(slide, getAnalysisType(model.id)), {
        target: '_blank',
      });
    }
  };

  const slideURL = isExists
    ? getSlideViewerURL(slide, getAnalysisType(model.id))
    : SLIDE_VIEWER_URL.replace(':slideUUID', slide.uuid);

  const isStainError = isStainTypeMismatch(slide, model);
  const isOrganError = isOrganMismatch(slide, model);
  const isSpeciesError = isSpeciesMismatch(slide, model);

  const handleCheckboxChange = () => {
    if (isChecked) {
      setAvailableToProcessSlides((prev) =>
        prev.filter((slideUUID) => slideUUID !== slide.uuid),
      );

      return;
    }

    setAvailableToProcessSlides((prev) => [...prev, slide.uuid]);
  };

  const isDisabled =
    isStainError ||
    isSpeciesError ||
    isOrganError ||
    isExists ||
    isCompatibleDataMissing(slide, model);

  return (
    <Box className={classes.confirmSlide} onClick={handleOpenResult}>
      <Checkbox
        disabled={isDisabled}
        checked={isChecked}
        onChange={handleCheckboxChange}
        disableRipple
        size="small"
        className={classes.checkbox}
        icon={isDisabled ? <IndeterminateCheckBoxOutlined /> : undefined}
      />
      <Typography className={classes.tableIcon}>
        {getModalCompatibilityIcon(slide, model)}
      </Typography>
      <Link href={slideURL} target="_blank" className={classes.confirmName}>
        {slide.name}
      </Link>
      {!isExists ? (
        <>
          <Typography
            className={`${classes.slideField} ${
              isOrganError ? classes.fieldError : ''
            }`}
          >
            <ErrorOutlineOutlined className={classes.fieldErrorIcon} />
            {slide.sample?.organ?.name || '-'}
          </Typography>
          <Typography
            className={`${classes.slideField} ${
              isSpeciesError ? classes.fieldError : ''
            }`}
          >
            <ErrorOutlineOutlined className={classes.fieldErrorIcon} />
            {slide.sample?.species?.name || '-'}
          </Typography>
          <Typography
            className={`${classes.slideField} ${
              isStainError ? classes.fieldError : ''
            }`}
          >
            <ErrorOutlineOutlined className={classes.fieldErrorIcon} />
            {STAIN_TYPE_VALUES[slide.stain_type] || '-'}
          </Typography>
        </>
      ) : (
        <>
          <span />
          <Link
            href={getSlideViewerURL(slide, getAnalysisType(model.id))}
            target="_blank"
            textAlign="center"
            className={classes.viewResult}
          >
            View Result
          </Link>
          <span />
        </>
      )}
    </Box>
  );
};
